import React,{useEffect} from 'react';
import { motion } from 'framer-motion';
import Faq from './faq';
import HowItWorks from './howitworks';
import Services from './services';
import WhyChooseUs from './whychooseus';
import Button from '../button';
import WrongParkingGallery from './wrongparkinggallery';

const { default: Hero } = require('./hero');

const Home = () => {

    useEffect(() => {
        // Scroll to the top of the page on component load
        window.scrollTo(0, 0);
      }, []);
  return (
    <>
      {/* Hero Section */}
      <Hero />
      
      {/* Services Section with animation */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }} // Ensures the animation only happens once when the element is in view
      >
        <Services />
      </motion.div>

      {/* Why Choose Us Section with animation */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <WhyChooseUs />
      </motion.div>


 <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <WrongParkingGallery />
      </motion.div>
      {/* How It Works Section with animation */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <HowItWorks />
      </motion.div>

      {/* FAQ Section with animation */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <Faq />
        <Button/>
      </motion.div>
    </>
  );
};

export default Home;
